import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import SubMenu from "../SubMenu";
import React, { FC } from "react";
import DescriptionIcon from "@material-ui/icons/Description";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import customerReceipts from "../../../pages/customerReceipts";
import customerCards from "../../../pages/customerCards";
import companies from "../../../pages/companies";
import personInCharges from "../../../pages/personInCharges";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import SectionComponent from "../SectionComponent";

interface PaymentsAndFinanceMenuProps {
  permissions: string[];
}

const PaymentsAndFinanceMenu: FC<PaymentsAndFinanceMenuProps> = ({
  permissions,
}) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = [
    "unapprovedInvoices",
    "invoices",
    "unapprovedCreditNotes",
    "creditNotes",
    "customerReceipts",
    "customerCards",
    "companies",
    "personInCharges",
    "findCommercialDocumentFeatures",
  ];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Payments & Finance" : "P & F"}>
      <SubMenu
        name="Invoices"
        icon={<DescriptionIcon />}
        permissions={permissions}
        permissionResources={["unapprovedInvoices", "invoices"]}
      >
        <ProtectedMenuItemLink
          to={`/unapprovedInvoices`}
          primaryText={"Unapproved Invoices"}
          leftIcon={<DescriptionIcon />}
          permissions={permissions}
          permissionResource="unapprovedInvoices"
        />
        <ProtectedMenuItemLink
          to={`/invoices`}
          primaryText={"Invoices"}
          leftIcon={<DescriptionIcon />}
          permissions={permissions}
          permissionResource="invoices"
        />
      </SubMenu>
      <SubMenu
        name="Credit Notes"
        icon={<MoneyOffIcon />}
        permissions={permissions}
        permissionResources={["unapprovedCreditNotes", "creditNotes"]}
      >
        <ProtectedMenuItemLink
          to={`/unapprovedCreditNotes`}
          primaryText={"Unapproved Credit Notes"}
          leftIcon={<MoneyOffIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="unapprovedCreditNotes"
        />
        <ProtectedMenuItemLink
          to={`/creditNotes`}
          primaryText={"Credit Notes"}
          leftIcon={<MoneyOffIcon />}
          permissions={permissions}
          permissionResource="creditNotes"
        />
      </SubMenu>
      <ProtectedMenuItemLink
        to={`/customerReceipts`}
        primaryText={"Receipts"}
        leftIcon={<customerReceipts.icon />}
        permissions={permissions}
        permissionResource="customerReceipts"
      />
      <ProtectedMenuItemLink
        to={`/findCommercialDocumentFeatures`}
        primaryText={"Find Commercial Document"}
        leftIcon={<FindInPageIcon />}
        permissions={permissions}
        permissionResource="findCommercialDocumentFeatures"
      />
      <ProtectedMenuItemLink
        to={`/customerCards`}
        primaryText={"Parents with Due Balance"}
        leftIcon={<customerCards.icon />}
        style={{ whiteSpace: "normal" }}
        permissions={permissions}
        permissionResource="customerCards"
      />
      <ProtectedMenuItemLink
        to={`/companies`}
        primaryText={"Companies"}
        leftIcon={<companies.icon />}
        permissions={permissions}
        permissionResource="companies"
      />
      <ProtectedMenuItemLink
        to={`/personInCharges`}
        primaryText={"Person In Charges"}
        leftIcon={<personInCharges.icon />}
        permissions={permissions}
        permissionResource="personInCharges"
      />
    </SectionComponent>
  );
};

export default PaymentsAndFinanceMenu;
